import { toFlagId } from '@atlassian/jira-flags';

export const CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY =
	'jira.user.theme.custom-nav-bar-flag.dismissed';
export const CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY =
	'jira.user.theme.custom-nav-bar-section-message.dismissed';
export const CUSTOM_NAV_BAR_COLORS_FLAG_ID: string = toFlagId('onThemeChangeCustomColorsFlag');

export const HELP_ARTICLE_ID = '1QC8AUgw7MAmoVtoYXQDxM';
